export default "__VITE_ASSET__57a3affe__"